<template>
  <!-- 角色权限分配 -->
  <div class="permission-container">
    <div class="topbox">
      <div class="headerboxs">
        <!-- <el-button class="seniorbut2" @click="goBackPage">返回上一页</el-button> -->
        <el-button class="seniorbut glo_bgcMainColor" @click="preservation"
          >保存</el-button
        >
      </div>
      <div class="Rolebox">
        <!-- <div class="RoleInfobox">角色编号:{{ roleinfo.roleId }}</div>
        <div class="RoleInfobox">角色名称:{{ roleinfo.roleName }}</div> -->
        <div class="ClientPermission">
          <!-- <div class="title">各端默认登录权限</div> -->
          <div>
            <el-checkbox v-model="checkedAll3" @change="checkAllChange3"
              >全选</el-checkbox
            >
          </div>
          <div class="tableen">
            <el-tree
              ref="treeData3"
              class="permission-item"
              :data="tableData3"
              :props="customProps"
              show-checkbox
              node-key="menuId"
              @check="checkTree3"
              :default-expanded-keys="pIds"
              :default-checked-keys="checkedKeysArr3"
            >
            </el-tree>
          </div>
        </div>
        <div class="RoleInfobox">当前账号:{{ userName }}</div>
      </div>
    </div>
    <div class="tablebox">
      <div class="tableleft">
        <div class="tabletitl">管理端功能菜单权限</div>
        <div style="margin-bottom: 10px">
          <el-checkbox v-model="checkedAll" @change="checkAllChange"
            >全选</el-checkbox
          >
        </div>
        <div class="tableen">
          <el-tree
            ref="treeData"
            :data="tableData"
            :props="customProps"
            show-checkbox
            node-key="menuId"
            @check="checkTree"
            :default-expanded-keys="pIds"
            :default-checked-keys="checkedKeysArr"
          >
          </el-tree>
        </div>
      </div>
      <div class="tableleft">
        <div class="tabletitl">司机端菜单权限</div>
        <div style="margin-bottom: 10px">
          <el-checkbox v-model="checkedAll2" @change="checkAllChange2"
            >全选</el-checkbox
          >
        </div>
        <div class="tableen">
          <el-tree
            ref="treeData2"
            :data="tableData2"
            :props="customProps"
            show-checkbox
            node-key="menuId"
            @check="checkTree2"
            :default-expanded-keys="pIds"
            :default-checked-keys="checkedKeysArr2"
          >
          </el-tree>
        </div>
      </div>
      <div class="tableright">
        <div class="tabletitl">VIP PC端菜单权限</div>
        <div style="margin-bottom: 10px">
          <el-checkbox v-model="checkedAll4" @change="checkAllChange4"
            >全选</el-checkbox
          >
        </div>
        <div class="tableen">
          <el-tree
            ref="treeData4"
            :data="tableData4"
            :props="customProps"
            show-checkbox
            node-key="menuId"
            @check="checkTree4"
            :default-expanded-keys="pIds"
            :default-checked-keys="checkedKeysArr4"
          >
          </el-tree>
        </div>
      </div>

      <div class="tableright">
        <div class="tabletitl">用户端菜单权限</div>
        <div style="margin-bottom: 10px">
          <el-checkbox v-model="checkedAll5" @change="checkAllChange5"
            >全选</el-checkbox
          >
        </div>
        <div class="tableen">
          <el-tree
            ref="treeData5"
            :data="tableData5"
            :props="customProps"
            show-checkbox
            node-key="menuId"
            @check="checkTree5"
            :default-expanded-keys="pIds"
            :default-checked-keys="checkedKeysArr5"
          >
          </el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tools from "@/assets/js/tool";
export default {
  inject: ["reload"],
  data() {
    return {
      newPermissArr: [],
      roleArray: {
        menuIds: [], //权限id数组
        roleId: "", //要操作的角色id
      },
      multipleSelection: [], //勾选的数据
      roleinfo: "", //角色详情
      tableData: [], //管理端菜单
      tableData2: [], //员工端菜单
      tableData4: [], // 客户端菜单
      tableData5: [], // 客户端菜单
      tableData3: [], //登录权限
      customProps: {
        // children: "childMenu",
        label: "menuName",
      },
      AllPermissList: [], //登录用户所有的权限
      pIds: [], //当前展开的
      checkedKeysList: [], //当前选中的全部菜单id数组
      checkedKeysList2: [], //当前选中的全部菜单id数组
      checkedKeysList3: [], //当前选中的全部菜单id数组
      checkedKeysList4: [],
      checkedKeysList5: [],
      checkedKeysArr: [], //当前选中的子菜单id数组
      checkedKeysArr2: [], //当前选中的子菜单id数组
      checkedKeysArr3: [], //当前选中的子菜单id数组
      checkedKeysArr4: [],
      checkedKeysArr5: [],
      parentids: [],
      checkedAll: false,
      checkedAll2: false,
      checkedAll3: false,
      checkedAll4: false,
      checkedAll5: false,
      jspmpList: [],
      userList: [],
      loginsList: [],
      memberList: [],
      customerList:[],
      userName: "",
    };
  },
  created() {},
  mounted() {},
  activated() {
    if (this.$route.query.nid) {
      this.userId = this.$route.query.nid;
      this.getdata();
    }
    if (this.$route.query.nid) {
      //用户id
      this.userId = this.$route.query.nid;
    }
    if (this.$route.query.userName) {
      //用户id
      this.userName = this.$route.query.userName;
    }
  },
  methods: {
    // 全选(管理端)
    checkAllChange() {
      if (this.checkedAll) {
        this.$nextTick(() => {
          this.$refs.treeData.setCheckedNodes(this.tableData);
          let arrs = this.getAllIds(this.tableData, []) || [];
          this.checkedKeysList = arrs;
        });
      } else {
        this.$nextTick(() => {
          this.$refs.treeData.setCheckedNodes([]);
          this.checkedKeysList = [];
        });
      }
    },
    // 全选(会员端)
    checkAllChange2() {
      if (this.checkedAll2) {
        this.$nextTick(() => {
          this.$refs.treeData2.setCheckedNodes(this.tableData2);
          let arrs = this.getAllIds(this.tableData2, []) || [];
          this.checkedKeysList2 = arrs;
        });
      } else {
        this.$nextTick(() => {
          this.$refs.treeData2.setCheckedNodes([]);
          this.checkedKeysList2 = [];
        });
      }
    },
    // 全选(会员端)
    checkAllChange3() {
      if (this.checkedAll3) {
        this.$nextTick(() => {
          this.$refs.treeData3.setCheckedNodes(this.tableData3);
          let arrs = this.getAllIds(this.tableData3, []) || [];
          this.checkedKeysList3 = arrs;
        });
      } else {
        this.$nextTick(() => {
          this.$refs.treeData3.setCheckedNodes([]);
          this.checkedKeysList3 = [];
        });
      }
    },
    // 全选(会员端)
    checkAllChange4() {
      if (this.checkedAll4) {
        this.$nextTick(() => {
          this.$refs.treeData4.setCheckedNodes(this.tableData4);
          let arrs = this.getAllIds(this.tableData4, []) || [];
          this.checkedKeysList4 = arrs;
        });
      } else {
        this.$nextTick(() => {
          this.$refs.treeData4.setCheckedNodes([]);
          this.checkedKeysList4 = [];
        });
      }
    },
    // 全选(会员端)
    checkAllChange5() {
      if (this.checkedAll5) {
        this.$nextTick(() => {
          this.$refs.treeData5.setCheckedNodes(this.tableData5);
          let arrs = this.getAllIds(this.tableData5, []) || [];
          this.checkedKeysList5 = arrs;
        });
      } else {
        this.$nextTick(() => {
          this.$refs.treeData5.setCheckedNodes([]);
          this.checkedKeysList5 = [];
        });
      }
    },
    //递归获取全部id
    getAllIds(arrs, pids) {
      let ids = pids || [];
      for (var i = 0; i < arrs.length; i++) {
        ids.push(arrs[i].menuId);
        if (arrs[i].children && arrs[i].children.length > 0) {
          this.getAllIds(arrs[i].children, ids);
        }
      }

      return ids;
    },
    getdata() {
      if (!this.userId) {
        return;
      }
      this.getLoginUserRoleMenuPerList();
    },

    // 用户角色菜单(当前登录用户全部菜单和权限)
    getLoginUserRoleMenuPerList() {
      this.$API.wtl_getLoginUserRoleMenuPerList().then((res) => {
        this.allMenuList = res.data.result.menuVoList || [];
        this.allPmList = res.data.result.permissionList || [];

        // let adminPList = [];
        // let memberPList = [];
        // allPmList.forEach((item) => {
        //   if (item.name.indexOf("user:") == -1) {
        //     adminPList.push(item);
        //   } else {
        //     memberPList.push(item);
        //   }
        // });
        // this.allPmList = adminPList;
        // this.memberPList = memberPList;
        //
        this.getUserRoleMenuPerList();
        this.getMenuList(this.allMenuList, this.allPmList);
      });
    },

    //根据用户id获取用户的菜单权限列表
    getUserRoleMenuPerList() {
      this.$API
        .wtl_getUserRoleMenuPerList({ userId: this.userId })
        .then((res) => {
          let tdata = res.data.result.menuVoList || [];
          let qxdata = res.data.result.permissionList || [];

          this.getMenuList(tdata, qxdata);
        });
    },

    //获取处理后的菜单数组
    getMenuList(tdata, qxdata) {
      let menuList = this.allMenuList || [];
      // 合并
      let concatMenuList = [...menuList, ...tdata];
      let newpIds = [];
      let newMenuList = [];

      // 去重
      for (var i = 0; i < concatMenuList.length; i++) {
        if (newpIds.indexOf(concatMenuList[i].menuId) == -1) {
          newpIds.push(concatMenuList[i].menuId);
          let obj = {
            menuName: concatMenuList[i].menuName || "",
            menuId: concatMenuList[i].menuId || "",
            isThisRole: concatMenuList[i].isThisRole || 0,
            number: concatMenuList[i].number || "",
            parentId: concatMenuList[i].parentId,
            jumpUrl: concatMenuList[i].jumpUrl || "",
            icon: concatMenuList[i].icon || "",
            sort: concatMenuList[i].sort || 100,
          };
          newMenuList.push(obj);
        } else {
          if (concatMenuList[i].isThisRole == 1) {
            let idx = newpIds.indexOf(concatMenuList[i].menuId);
            newMenuList[idx].isThisRole = 1;
          }
        }
      }

      let pmList = this.getUserRolePermissionList(qxdata);
      let arr2 = [];
      for (var d = 0; d < pmList.length; d++) {
        let obj = {
          menuName: pmList[d].menuName + " (权限)",
          menuId: pmList[d].menuId,
          isThisRole: pmList[d].isThisRole,
          parentId: pmList[d].parentId,
          number: pmList[d].number,
          sort: 100,
        };
        arr2.push(obj);
      }
      let menuPermissList = [...arr2, ...newMenuList];
      //jspmpList 是权限和菜单整合的列表,权限的menuId = p+权限id
      let jspmpList = JSON.parse(JSON.stringify(menuPermissList));

      let staffList = []; // 后台权限
      let userList = []; //员gong端的权限
      let memberList = []; // 客户端权限
      let customerList=[];// 用户端
      let loginsList = []; //各端的默认权限
      for (var u = 0; u < jspmpList.length; u++) {
        // 提取各端的默认登录权限
        if (
          jspmpList[u].number == "pda:permission:default" ||
          // jspmpList[u].number == "admindevops:permission:default" ||
          jspmpList[u].number == "admin:permission:default" ||
          jspmpList[u].number == "pc:vip:permission:default" ||
          jspmpList[u].number == "member:permission:default"
        ) {
          loginsList.push(jspmpList[u]);
          continue;
        }
        // 提取会员端的权限
        if (jspmpList[u].number.indexOf("app:driver:") !== -1) {
          userList.push(jspmpList[u]);
          continue;
        }
        if (
          jspmpList[u].number.indexOf("pc:vip:") !== -1
          // jspmpList[u].number.indexOf("app:driver:") !== -1
        ) {
          memberList.push(jspmpList[u]);
          continue;
        }
        if (
          (jspmpList[u].number.indexOf("driver:") !== -1 &&
            jspmpList[u].number.indexOf("app:") !== -1) ||
          jspmpList[u].number.indexOf("appDriver:") !== -1
        ) {
          continue;
        }
        if (
          jspmpList[u].number.indexOf("member:") !== -1
          // jspmpList[u].number.indexOf("app:driver:") !== -1
        ) {
          customerList.push(jspmpList[u]);
          continue;
        }
        staffList.push(jspmpList[u]);
      }
      // loginsList = [loginsList[1], loginsList[0], loginsList[2]];
      const loginsList2 = []
      let permission = loginsList.filter(item=>item.number === 'admin:permission:default')
      if(permission.length > 0){
        loginsList2.push(permission[0])        
      }
      permission = loginsList.filter(item=>item.number === 'pda:permission:default')
      if(permission.length > 0){
        loginsList2.push(permission[0])        
      }
      permission = loginsList.filter(item=>item.number === 'pc:vip:permission:default')
      if(permission.length > 0){
        loginsList2.push(permission[0])        
      }
      permission = loginsList.filter(item=>item.number === 'member:permission:default')
      if(permission.length > 0){
        loginsList2.push(permission[0])        
      }
      loginsList = loginsList2
      this.tableData2 = userList;
      this.tableData3 = loginsList;
      this.tableData4 = memberList;
      this.tableData5 = customerList
      // 判断是否全选时用
      this.jspmpList = staffList;
      this.userList = userList;
      this.loginsList = loginsList;
      this.memberList = memberList;
      this.customerList = customerList

      // 获取已有的权限(管理端)
      let checkKeys = [];
      for (var c = 0; c < staffList.length; c++) {
        if (staffList[c].isThisRole == 1) {
          checkKeys.push(staffList[c].menuId);
        }
      }
      this.checkedKeysList = checkKeys;
      if (checkKeys.length == staffList.length) {
        this.checkedAll = true;
      }
      // 获取已有的权限(会员端)
      let checkKeys2 = [];
      for (var c = 0; c < userList.length; c++) {
        if (userList[c].isThisRole == 1) {
          checkKeys2.push(userList[c].menuId);
        }
      }
      this.checkedKeysList2 = checkKeys2;
      if (checkKeys2.length == userList.length) {
        this.checkedAll2 = true;
      }
      // 获取已有的权限(各端默认)
      let checkKeys3 = [];
      for (var c = 0; c < loginsList.length; c++) {
        if (loginsList[c].isThisRole == 1) {
          checkKeys3.push(loginsList[c].menuId);
        }
      }
      this.checkedKeysList3 = checkKeys3;
      if (checkKeys3.length == loginsList.length) {
        this.checkedAll3 = true;
      }

      let checkKeys4 = [];
      for (var c = 0; c < memberList.length; c++) {
        if (memberList[c].isThisRole == 1) {
          checkKeys4.push(memberList[c].menuId);
        }
      }
      this.checkedKeysList4 = checkKeys4;
      if (checkKeys4.length == memberList.length) {
        this.checkedAll4 = true;
      }

      let checkKeys5 = [];
      for (var c = 0; c < customerList.length; c++) {
        if (customerList[c].isThisRole == 1) {
          checkKeys5.push(customerList[c].menuId);
        }
      }
      this.checkedKeysList5 = checkKeys5;
      if (checkKeys5.length == customerList.length) {
        this.checkedAll5 = true;
      }

      // 递归管理端的树表格结构
      let tabData = this.diGuiGetMeun(
        JSON.parse(JSON.stringify(staffList)),
        "-1",
        1
      );
      let tabData2 = this.diGuiGetMeun(
        JSON.parse(JSON.stringify(userList)),
        "-1",
        2
      );
      let tabData3 = this.diGuiGetMeun(
        JSON.parse(JSON.stringify(loginsList)),
        "-1",
        3
      );

      let tabData4 = this.diGuiGetMeun(
        JSON.parse(JSON.stringify(memberList)),
        "-1",
        4
      );

      let tabData5 = this.diGuiGetMeun(
        JSON.parse(JSON.stringify(customerList)),
        "-1",
        5
      );

      //默认展开的数组(管理端)
      let parIds = this.getParentIds(tabData);
      let allKeys = JSON.parse(JSON.stringify(checkKeys));
      let pKeys = JSON.parse(JSON.stringify(parIds));
      for (let w = 0; w < allKeys.length; w++) {
        for (let r = 0; r < pKeys.length; r++) {
          if (pKeys[r] == allKeys[w]) {
            allKeys.splice(w, 1);
            w--;
          }
        }
      }
      this.checkedKeysArr = allKeys;

      //默认展开的数组(员工端)
      let parIds2 = this.getParentIds(tabData2);
      let allKeys2 = JSON.parse(JSON.stringify(checkKeys2));
      let pKeys2 = JSON.parse(JSON.stringify(parIds2));
      for (let w = 0; w < allKeys2.length; w++) {
        for (let r = 0; r < pKeys2.length; r++) {
          if (pKeys2[r] == allKeys2[w]) {
            allKeys2.splice(w, 1);
            w--;
          }
        }
      }
      this.checkedKeysArr2 = allKeys2;

      //默认展开的数组(各端默认)
      let parIds3 = this.getParentIds(tabData3);
      let allKeys3 = JSON.parse(JSON.stringify(checkKeys3));
      let pKeys3 = JSON.parse(JSON.stringify(parIds3));
      for (let w = 0; w < allKeys3.length; w++) {
        for (let r = 0; r < pKeys3.length; r++) {
          if (pKeys3[r] == allKeys3[w]) {
            allKeys3.splice(w, 1);
            w--;
          }
        }
      }
      this.checkedKeysArr3 = allKeys3;

      //默认展开的数组(会员端)
      let parIds4 = this.getParentIds(tabData4);
      let allKeys4 = JSON.parse(JSON.stringify(checkKeys4));
      let pKeys4 = JSON.parse(JSON.stringify(parIds4));
      for (let w = 0; w < allKeys4.length; w++) {
        for (let r = 0; r < pKeys4.length; r++) {
          if (pKeys4[r] == allKeys4[w]) {
            allKeys4.splice(w, 1);
            w--;
          }
        }
      }
      this.checkedKeysArr4 = allKeys4;

      //默认展开的数组(会员端)
      let parIds5 = this.getParentIds(tabData5);
      let allKeys5 = JSON.parse(JSON.stringify(checkKeys5));
      let pKeys5 = JSON.parse(JSON.stringify(parIds5));
      for (let w = 0; w < allKeys5.length; w++) {
        for (let r = 0; r < pKeys5.length; r++) {
          if (pKeys5[r] == allKeys5[w]) {
            allKeys5.splice(w, 1);
            w--;
          }
        }
      }
      this.checkedKeysArr5 = allKeys5;
    },
    // 找出父节点
    getParentIds(tabData) {
      tabData.forEach((item) => {
        if (item.children && item.children.length > 0) {
          this.parentids.push(item.menuId);
          this.getParentIds(item.children);
        }
      });
      return this.parentids;
    },

    //获取处理后的权限数组
    getUserRolePermissionList(qxdata) {
      let that = this;
      let permissList = JSON.parse(JSON.stringify(this.allPmList)) || [];
      let concatPermissList = [...permissList, ...qxdata];
      let concatArrplist = JSON.parse(JSON.stringify(concatPermissList));
      let newpIds = [];
      let newPermissList = [];

      // 去重
      for (var i = 0; i < concatArrplist.length; i++) {
        if (newpIds.indexOf(concatArrplist[i].permissionId) < 0) {
          newpIds.push(concatArrplist[i].permissionId);
          concatArrplist[i].menuId = concatArrplist[i].menuId || "-1";
          newPermissList.push(concatArrplist[i]);
        } else {
          if (concatArrplist[i].isThisRole == 1) {
            let idx = newpIds.indexOf(concatArrplist[i].permissionId);
            newPermissList[idx].isThisRole = 1;
          }
          if (concatArrplist[i].menuId && concatArrplist[i].menuId != null) {
            let idx = newpIds.indexOf(concatArrplist[i].permissionId);
            newPermissList[idx].menuId = concatArrplist[i].menuId;
          }
        }
      }

      // this.newPermissArr = newPermissList;
      let arr3 = [];
      for (var x = 0; x < newPermissList.length; x++) {
        let obj = {
          menuName: newPermissList[x].permissionName,
          menuId: "p" + newPermissList[x].permissionId,
          isThisRole: newPermissList[x].isThisRole,
          parentId: newPermissList[x].menuId,
          number: newPermissList[x].name,
          sort: "1",
        };
        arr3.push(obj);
      }
      return arr3;

      // that.$nextTick(() => {
      //   for (let i = 0; i < this.newPermissArr.length; i++) {
      //     if (this.newPermissArr[i].isThisRole == 1) {
      //       that.$refs.multipleTable.toggleRowSelection(
      //         that.newPermissArr[i],
      //         true
      //       );
      //     }
      //   }
      // });
    },
    // 勾选复选框(管理端)
    checkTree(a, b) {
      let checkArr1 = b.checkedKeys || [];
      let checkArr2 = b.halfCheckedKeys || [];
      let checkedArr = [...checkArr1, ...checkArr2];
      this.checkedKeysArr = checkArr1;
      this.checkedKeysList = checkedArr;
      if (this.checkedKeysList.length !== this.jspmpList.length) {
        this.checkedAll = false;
      } else {
        this.checkedAll = true;
      }
    },
    // 勾选复选框(会员端)
    checkTree2(a, b) {
      let checkArr1 = b.checkedKeys || [];
      let checkArr2 = b.halfCheckedKeys || [];
      let checkedArr = [...checkArr1, ...checkArr2];
      this.checkedKeysArr2 = checkArr1;
      this.checkedKeysList2 = checkedArr;
      if (this.checkedKeysList2.length !== this.userList.length) {
        this.checkedAll2 = false;
      } else {
        this.checkedAll2 = true;
      }
    },
    // 勾选复选框()
    checkTree3(a, b) {
      let checkArr1 = b.checkedKeys || [];
      let checkArr2 = b.halfCheckedKeys || [];
      let checkedArr = [...checkArr1, ...checkArr2];
      this.checkedKeysArr3 = checkArr1;
      this.checkedKeysList3 = checkedArr;
      if (this.checkedKeysList3.length !== this.loginsList.length) {
        this.checkedAll3 = false;
      } else {
        this.checkedAll3 = true;
      }
    },
    checkTree4(a, b) {
      let checkArr1 = b.checkedKeys || [];
      let checkArr2 = b.halfCheckedKeys || [];
      let checkedArr = [...checkArr1, ...checkArr2];
      this.checkedKeysArr4 = checkArr1;
      this.checkedKeysList4 = checkedArr;
      if (this.checkedKeysList4.length !== this.memberList.length) {
        this.checkedAll4 = false;
      } else {
        this.checkedAll4 = true;
      }
    },
    checkTree5(a, b) {
      let checkArr1 = b.checkedKeys || [];
      let checkArr2 = b.halfCheckedKeys || [];
      let checkedArr = [...checkArr1, ...checkArr2];
      this.checkedKeysArr5 = checkArr1;
      this.checkedKeysList5 = checkedArr;
      if (this.checkedKeysList5.length !== this.customerList.length) {
        this.checkedAll5 = false;
      } else {
        this.checkedAll5 = true;
      }
    },
    //获取功能权限id
    handleSelectionChange1(val) {
      let pIds = [];
      for (var i = 0; i < val.length; i++) {
        pIds.push(val[i].permissionId);
      }
      this.pIds = pIds;
    },
    goBackPage() {
      tools.closePage(this);
    },
    //保存按钮
    preservation() {
      let _this = this;
      let AllCheckIds = [
        ...this.checkedKeysList,
        ...this.checkedKeysList2,
        ...this.checkedKeysList3,
        ...this.checkedKeysList4,
        ...this.checkedKeysList5
      ];
      // if (AllCheckIds.length < 1) {
      //   this.$message.warning("菜单不能为空");
      //   return;
      // }

      let menuKeys = []; //菜单id
      let permissKeys = []; //权限id
      // 菜单id有p的是权限id,没有的是菜单id
      for (let i = 0; i < AllCheckIds.length; i++) {
        if (AllCheckIds[i].indexOf("p") == -1) {
          menuKeys.push(AllCheckIds[i]);
        } else {
          permissKeys.push(AllCheckIds[i]);
        }
      }

      let pmArr1 = [];
      permissKeys.forEach((item) => {
        let val = item.replace("p", "");
        pmArr1.push(val);
      });

      // 保存权限
      let param2 = {
        permissionIds: pmArr1, //权限id数组
        menuIds: menuKeys,
        userId: this.userId, //角色id
      };
      this.$API.wtl_savaUserPermission(param2).then((res) => {
        this.$message({
          message: res.data.message || "分配权限成功",
          type: "success",
        });
        setTimeout(() => {
          tools.closePage(this);
        }, 1000);
      });
    },

    //递归获取数据
    diGuiGetMeun(data, parentId, type) {
      let tree = [];
      let temp;
      data.forEach((item) => {
        if (item.parentId == parentId) {
          let obj = item;
          obj.menuName = item.menuName;
          temp = this.diGuiGetMeun(data, item.menuId, type);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      });
      //排序
      for (var i = 0; i < tree.length - 1; i++) {
        for (var j = 0; j < tree.length - 1 - i; j++) {
          if (tree[j].sort > tree[j + 1].sort) {
            let temp = tree[j + 1];
            tree[j + 1] = tree[j];
            tree[j] = temp;
          }
        }
      }
      if (type == 1) {
        this.tableData = tree
      }
      if (type == 2) {
        this.tableData2 = tree;
      }
      if (type == 3) {
        this.tableData3 = tree;
      }
      if (type == 4) {
        this.tableData4 = tree;
      }
      if (type == 5) {
        this.tableData5 = tree;
      }
      return tree;
    },
  },
};
</script>

<style lang="less" scoped>
.permission-container {
  display: flex;
  flex-flow: column;
  height: calc(100vh - 80px);
}
.headerboxs {
  width: 100%;
  padding: 4px 0;
  box-sizing: border-box;
  display: flex;

  ::v-deep {
    .el-button {
      padding: 6px 10px;
    }
  }

  .seniorbut2 {
    // padding: 10px 0;
    // width: 100px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #d7d7d7;
  }
}
.Rolebox {
  width: 100%;
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .RoleInfobox {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
    font-size: 14px;
  }
  .ClientPermission {
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 10px;
    .title {
      padding: 20px 0;
    }
    .permission-item {
      display: flex;
    }
  }
}
.tablebox {
  flex: 1;
  overflow: hidden;
  display: flex;
  border-top: 1px solid #d7d7d7;
  .tableleft {
    flex: 1;
    border-right: 1px solid #d7d7d7;
    margin-right: 10px;
    padding-left: 10px;
    display: flex;
    flex-flow: column;
  }
  .tableright {
    flex: 1;
    padding-left: 10px;
    display: flex;
    flex-flow: column;
  }
}
.tabletitl {
  width: 100%;
  display: flex;
  padding: 20px 0;
}
.tableen {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: center;
  overflow: auto;
}
</style>>